export class ImageUpScalarRequestModel {
  file : File | null=null;
}

export class ImageUpScalarResponseModel{
  base64_image!:string;
  content_type!:string;
}
